import React, {useEffect, useState} from 'react';
import Joi from 'joi';
import {SeaService} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import {useFieldData} from 'components/forms/hooks';
import {PrettyPrintYMD} from 'components/forms/fields/SeaService';

const schema = {
    year_month_days_input_json: Joi.object().unknown(true),
};
const initialValues = {
    year_month_days_input_json: {},
};

const flattenObj = ob => {
    let result = {};
    for (const i in ob) {
        if (typeof ob[i] === 'object' && !Array.isArray(ob[i])) {
            const temp = flattenObj(ob[i]);
            for (const j in temp) {
                // Store temp in result
                result[i + '.' + j] = temp[j];
            }
        }
        // Else store ob[i] in result directly
        else {
            result[i] = ob[i];
        }
    }
    return result;
};

const sumValues = obj => Object.values(obj).reduce((a, b) => a + b, 0);

const SeaServiceDays = props => {
    const [data, setMYD] = useFieldData('year_month_days_input_json');
    const [totalSSDays, setTotalSSDays] = useState();

    useEffect(() => {
        if (Object.values(data).length > 0) {
            setTotalSSDays(sumValues(flattenObj(data)));
        } else {
            setTotalSSDays(0);
        }

        // eslint-disable-next-line
    }, [data]);

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Sea Service Days Breakdown
            </Typography>
            <Typography variant='body1'>
            Enter in every day you were underway for over 4 hours each month and year.
            </Typography>
            <Typography variant='body1'>
                <b>Total Entered: {totalSSDays}</b>
            </Typography>

            <SeaService
                label='Sea Service Days'
                name='year_month_days_input_json'
                onChange={setMYD}
            />
            <Typography variant='body1'>
                Use the arrow buttons or dropdown to select the month. Once
                you've entered the year and number of days, use the plus button
                to save the record to the system. If you need to delete an
                entry, select the checkbox and then click the trash icon. Your
                entered days will show below.{' '}
                <b>Please check all numbers below before proceeding!</b>
            </Typography>
            <Typography variant='body1'>
                <b>You have entered Days</b>
                <b>Total: {totalSSDays}</b>
                <PrettyPrintYMD data={JSON.stringify(data)} />
            </Typography>
            {props.children}
        </Section>
    );
};

export default SeaServiceDays;
export {flattenObj, sumValues};
